import { UserReauthDialog } from './UserReauthDialog';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  userLabel: string;
  loading?: boolean;
  onSubmit: (credentials: { password: string; code: string }) => void;
}

export function UserTwoFactorResetDialog({
  open,
  onOpenChange,
  userLabel,
  loading,
  onSubmit,
}: Props) {
  return (
    <UserReauthDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Zwei-Faktor-Anmeldung zurücksetzen"
      userLabel={userLabel}
      confirmLabel="Faktor zurücksetzen"
      confirmVariant="destructive"
      loading={loading}
      onSubmit={onSubmit}
    >
      <p>
        Alle Sitzungen und bisherigen Faktoren dieses Nutzers werden ungültig. Bei aktiver
        Workspace-Pflicht muss die Einrichtung beim nächsten Login erneut erfolgen.
      </p>
    </UserReauthDialog>
  );
}
